import { Button, Result } from "antd";
import { Link } from "react-router-dom";
import { ROUTES } from "@/consts";

const NotAuthorized = () => (
	<Result
		status="403"
		title="Not authorized"
		subTitle="You don't have permission to view this page."
		extra={
			<Link to={ROUTES.home}>
				<Button type="primary">Back Home</Button>
			</Link>
		}
	/>
);

export default NotAuthorized;
